// extracted by mini-css-extract-plugin
export default {"tabLink":"tabLink--Pg0tw","activeTab":"activeTab--F98Cj"};